import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import PersonalArea from './pages/PersonalArea'
import Paywall from './pages/Paywall'
import SubscriptionSuccess from './pages/SubscriptionSuccess'
import { AnalyticsProvider } from './context/AnalyticsContext'
import { AuthProvider } from './context/AuthContext'
import { NewLikesProvider } from './context/NewLikesContext'
import { ReadChatsProvider } from './context/ReadChatsContext'
import ScrollToTop from './components/ScrollToTop'
import OnboardingGender from './pages/onboarding/OnboardingGender'
import OnboardingName from './pages/onboarding/OnboardingName'
import OnboardingBirth from './pages/onboarding/OnboardingBirth'
import OnboardingInterests from './pages/onboarding/OnboardingInterests'
import OnboardingLookingFor from './pages/onboarding/OnboardingLookingFor'
import OnboardingReading from './pages/onboarding/OnboardingReading'
import OnboardingTeaser from './pages/onboarding/OnboardingTeaser'
import OnboardingPhotos from './pages/onboarding/OnboardingPhotos'
import OnboardingEmail from './pages/onboarding/OnboardingEmail'
import OnboardingPasswordNew from './pages/onboarding/OnboardingPasswordNew'
import OnboardingPasswordExisting from './pages/onboarding/OnboardingPasswordExisting'
import OnboardingFinal from './pages/onboarding/OnboardingFinal'
import ResetPassword from './pages/ResetPassword'
import AuthFromEmail from './pages/AuthFromEmail'
import ChatDetail from './pages/ChatDetail'
import Login from './pages/Login'
import LoginPassword from './pages/LoginPassword'
import ProfileEdit from './pages/ProfileEdit'
import ProfileSettings from './pages/ProfileSettings'
import SettingsEmailNotifications from './pages/settings/SettingsEmailNotifications'
import SettingsSubscriptions from './pages/settings/SettingsSubscriptions'
import SettingsAccount from './pages/settings/SettingsAccount'
import SettingsChangePassword from './pages/settings/SettingsChangePassword'
import SettingsLegal from './pages/settings/SettingsLegal'
import SettingsLegalDoc from './pages/settings/SettingsLegalDoc'
import SettingsPrivacy from './pages/settings/SettingsPrivacy'
import SettingsLanguage from './pages/settings/SettingsLanguage'
import VisualViewportCTA from './components/VisualViewportCTA'
import LastSeenUpdater from './components/LastSeenUpdater'
import PostHogIdentify from './components/PostHogIdentify'
import PublicLegalDoc from './pages/PublicLegalDoc'

function App() {
  return (
    <AnalyticsProvider>
      <AuthProvider>
        <Router>
          <PostHogIdentify />
          <ScrollToTop />
          <LastSeenUpdater />
          <VisualViewportCTA />
          <ReadChatsProvider>
          <NewLikesProvider>
          <Routes>
            <Route path="/" element={<OnboardingGender />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login/password" element={<LoginPassword />} />
            <Route path="/onboarding/name" element={<OnboardingName />} />
            <Route path="/onboarding/birth" element={<OnboardingBirth />} />
            <Route path="/onboarding/interests" element={<OnboardingInterests />} />
            <Route path="/onboarding/looking-for" element={<OnboardingLookingFor />} />
            <Route path="/onboarding/reading" element={<OnboardingReading />} />
            <Route path="/onboarding/teaser" element={<OnboardingTeaser />} />
            <Route path="/onboarding/photos" element={<OnboardingPhotos />} />
            <Route path="/onboarding/email" element={<OnboardingEmail />} />
            <Route path="/onboarding/password/new" element={<OnboardingPasswordNew />} />
            <Route path="/onboarding/password/existing" element={<OnboardingPasswordExisting />} />
            <Route path="/onboarding/final" element={<OnboardingFinal />} />

            {/* Страница для восстановления пароля по ссылке из письма */}
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Вход по одноразовой ссылке из писем (magic link, 30 мин) */}
            <Route path="/auth/from-email" element={<AuthFromEmail />} />

            {/* Публичные юридические документы */}
            <Route path="/legal/:docId" element={<PublicLegalDoc />} />

            <Route path="/app" element={<PersonalArea />} />
            <Route path="/app/people" element={<PersonalArea />} />
            <Route path="/app/chats" element={<PersonalArea />} />
            <Route path="/app/likes" element={<PersonalArea />} />
            <Route path="/app/profile" element={<PersonalArea />} />
            <Route path="/app/profile/edit/:section" element={<ProfileEdit />} />
            <Route path="/app/profile/settings/notifications" element={<SettingsEmailNotifications />} />
            <Route path="/app/profile/settings/subscriptions" element={<SettingsSubscriptions />} />
            <Route path="/app/profile/settings/account/change-password" element={<SettingsChangePassword />} />
            <Route path="/app/profile/settings/account" element={<SettingsAccount />} />
            <Route path="/app/profile/settings/language" element={<SettingsLanguage />} />
            <Route path="/app/profile/settings/legal/:docId" element={<SettingsLegalDoc />} />
            <Route path="/app/profile/settings/legal" element={<SettingsLegal />} />
            <Route path="/app/profile/settings/privacy" element={<SettingsPrivacy />} />
            <Route path="/app/profile/settings" element={<ProfileSettings />} />
            <Route path="/chat/new/:otherUserId" element={<ChatDetail />} />
            <Route path="/chat/:chatId" element={<ChatDetail />} />
            <Route path="/paywall" element={<Paywall />} />
            <Route path="/subscription-success" element={<SubscriptionSuccess />} />
          </Routes>
          </NewLikesProvider>
          </ReadChatsProvider>
        </Router>
      </AuthProvider>
    </AnalyticsProvider>
  )
}

export default App

